const CANTIDAD_CONTACTOS_EMERGENCIA = 1;
const PARAMETRO_POPUP = "rs.perfilcandidato.solicitudEmpleo.actualizaTusDatos";

export default { CANTIDAD_CONTACTOS_EMERGENCIA, PARAMETRO_POPUP };
